export default __webpack_public_path__ + "static/media/about-us-banner.1cfb3293.webp";